import axios from "axios";
import { BASE_URL } from "../Common.api";

export const createDefaultAxios = (path: string, timeout?: number) => 
  axios.create({
    baseURL: BASE_URL + path,
    paramsSerializer: { indexes: null },
    timeout: timeout ?? 8000
  });